import { render, staticRenderFns } from "./weekCollect.vue?vue&type=template&id=0c180656&scoped=true"
import script from "./weekCollect.vue?vue&type=script&lang=js"
export * from "./weekCollect.vue?vue&type=script&lang=js"
import style0 from "./weekCollect.vue?vue&type=style&index=0&id=0c180656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c180656",
  null
  
)

export default component.exports